export default "__VITE_PUBLIC_ASSET__ea098335__"